var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("div", { staticClass: "box view-nav-bar" }, [
      _c("div", { staticClass: "d-flex align-items-center w-100" }, [
        _c(
          "div",
          { staticClass: "flex-grow-1" },
          [
            _c(
              "router-link",
              { staticClass: "mr-3", attrs: { to: "/admissions/cinema" } },
              [
                _c("icon", { attrs: { name: "chevron-left" } }),
                _vm._v(" Back\n                "),
              ],
              1
            ),
            _vm._v(" "),
            _c("strong", [_vm._v(_vm._s(_vm.theatreCode))]),
            _vm._v(" "),
            _vm.bucket.theatre_name
              ? _c("span", { staticClass: "ml-2" }, [
                  _vm._v(_vm._s(_vm.bucket.theatre_name)),
                  _vm.bucket.city
                    ? _c("span", [_vm._v(", " + _vm._s(_vm.bucket.city))])
                    : _vm._e(),
                ])
              : _vm._e(),
            _vm._v(" "),
            _c("span", { staticClass: "text-muted ml-2" }, [
              _vm._v(
                "— admissions per cinema year, all sessions vs. Brightfish preshow"
              ),
            ]),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "form",
          {
            staticClass: "form-inline",
            on: {
              submit: function ($event) {
                $event.preventDefault()
                return _vm.calculate.apply(null, arguments)
              },
            },
          },
          [
            _c(
              "label",
              { staticClass: "text-muted mr-2", attrs: { for: "last-years" } },
              [_vm._v("Last")]
            ),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model.number",
                  value: _vm.lastYears,
                  expression: "lastYears",
                  modifiers: { number: true },
                },
              ],
              staticClass: "form-control form-control-sm shx-th-60 text-right",
              attrs: {
                id: "last-years",
                type: "number",
                min: "1",
                max: _vm.visibleRows.length || 1,
                disabled: _vm.loading || !_vm.visibleRows.length,
              },
              domProps: { value: _vm.lastYears },
              on: {
                input: function ($event) {
                  if ($event.target.composing) return
                  _vm.lastYears = _vm._n($event.target.value)
                },
                blur: function ($event) {
                  return _vm.$forceUpdate()
                },
              },
            }),
            _vm._v(" "),
            _c("span", { staticClass: "text-muted mx-2" }, [_vm._v("years")]),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "btn btn-sm btn-outline-secondary",
                attrs: {
                  type: "submit",
                  disabled: _vm.loading || !_vm.visibleRows.length,
                },
              },
              [_vm._v("\n                    Calculate\n                ")]
            ),
          ]
        ),
      ]),
    ]),
    _vm._v(" "),
    _vm.result
      ? _c("div", { staticClass: "box" }, [
          _c("div", { staticClass: "box-content" }, [
            _c("table", { staticClass: "shx-table w-100 mt-2" }, [
              _vm._m(0),
              _vm._v(" "),
              _c("tbody", [
                _c("tr", [
                  _c("td", [
                    _c("strong", [
                      _vm._v(
                        "Last " +
                          _vm._s(_vm.result.years.length) +
                          " cinema year"
                      ),
                      _vm.result.years.length !== 1
                        ? _c("span", [_vm._v("s")])
                        : _vm._e(),
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "text-muted ml-2" }, [
                      _vm._v(
                        _vm._s(_vm.result.years[_vm.result.years.length - 1]) +
                          " – " +
                          _vm._s(_vm.result.years[0])
                      ),
                    ]),
                    _vm._v(" "),
                    _vm.result.capped
                      ? _c(
                          "span",
                          {
                            staticClass: "badge badge-warning ml-2",
                            attrs: {
                              title:
                                "Fewer cinema years available than requested",
                            },
                          },
                          [
                            _vm._v(
                              "only " +
                                _vm._s(_vm.result.years.length) +
                                " available"
                            ),
                          ]
                        )
                      : _vm._e(),
                  ]),
                  _vm._v(" "),
                  _c("td", { staticClass: "text-right" }, [
                    _vm._v(_vm._s(_vm.result.weeks)),
                  ]),
                  _vm._v(" "),
                  _c("td", { staticClass: "text-right" }, [
                    _vm._v(_vm._s(_vm.formatInt(_vm.result.admissions))),
                  ]),
                  _vm._v(" "),
                  _c("td", { staticClass: "text-right" }, [
                    _c("strong", [
                      _vm._v(
                        _vm._s(
                          _vm.result.weeks
                            ? _vm.formatInt(
                                _vm.result.admissions / _vm.result.weeks
                              )
                            : "—"
                        )
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("td", { staticClass: "text-right" }, [
                    _vm._v(
                      _vm._s(_vm.formatInt(_vm.result.admissions_preshow))
                    ),
                  ]),
                  _vm._v(" "),
                  _c("td", { staticClass: "text-right" }, [
                    _c("strong", [
                      _vm._v(
                        _vm._s(
                          _vm.result.weeks
                            ? _vm.formatInt(
                                _vm.result.admissions_preshow / _vm.result.weeks
                              )
                            : "—"
                        )
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("td", { staticClass: "text-right" }, [
                    _vm._v(
                      _vm._s(
                        _vm.pct(
                          _vm.result.admissions_preshow,
                          _vm.result.admissions
                        )
                      )
                    ),
                  ]),
                  _vm._v(" "),
                  _c("td", { staticClass: "text-right" }, [
                    _c("span", [
                      _vm._v(
                        _vm._s(
                          _vm.result.real_weighted != null
                            ? _vm.result.real_weighted + "%"
                            : "—"
                        )
                      ),
                    ]),
                    _vm._v(" "),
                    _vm.result.real_weighted != null &&
                    _vm.result.real_weighted <= 90
                      ? _c(
                          "span",
                          { staticClass: "badge badge-warning ml-1" },
                          [_vm._v("⚠")]
                        )
                      : _vm._e(),
                  ]),
                ]),
              ]),
            ]),
          ]),
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.loading
      ? _c("div", { staticClass: "box" }, [
          _c(
            "div",
            { staticClass: "box-content text-center text-muted py-4" },
            [_vm._v("Loading…")]
          ),
        ])
      : !_vm.visibleRows.length
      ? _c("div", { staticClass: "box" }, [
          _c(
            "div",
            { staticClass: "box-content text-center text-muted py-4" },
            [
              _vm._v(
                "No admissions data found for " + _vm._s(_vm.theatreCode) + "."
              ),
            ]
          ),
        ])
      : _c("div", { staticClass: "box" }, [
          _c("div", { staticClass: "box-content" }, [
            _c("table", { staticClass: "shx-table w-100 mt-2" }, [
              _vm._m(1),
              _vm._v(" "),
              _c(
                "tbody",
                _vm._l(_vm.visibleRows, function (row) {
                  return _c("tr", { key: row.year }, [
                    _c(
                      "td",
                      [
                        _c(
                          "router-link",
                          {
                            attrs: {
                              to:
                                "/admissions/cinema/" +
                                _vm.theatreCode +
                                "/" +
                                row.year,
                            },
                          },
                          [_vm._v(_vm._s(row.year))]
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("td", { staticClass: "text-right" }, [
                      _vm._v(_vm._s(row.weeks)),
                    ]),
                    _vm._v(" "),
                    _c("td", { staticClass: "text-right" }, [
                      _vm._v(_vm._s(_vm.formatInt(row.admissions))),
                    ]),
                    _vm._v(" "),
                    _c("td", { staticClass: "text-right" }, [
                      _vm._v(
                        _vm._s(
                          row.avg_week !== null
                            ? _vm.formatInt(row.avg_week)
                            : "—"
                        )
                      ),
                    ]),
                    _vm._v(" "),
                    _c("td", { staticClass: "text-right" }, [
                      _vm._v(_vm._s(_vm.formatInt(row.admissions_preshow))),
                    ]),
                    _vm._v(" "),
                    _c("td", { staticClass: "text-right" }, [
                      _vm._v(
                        _vm._s(
                          row.avg_week_preshow !== null
                            ? _vm.formatInt(row.avg_week_preshow)
                            : "—"
                        )
                      ),
                    ]),
                    _vm._v(" "),
                    _c("td", { staticClass: "text-right" }, [
                      _vm._v(
                        _vm._s(
                          row.pct_preshow !== null ? row.pct_preshow + "%" : "—"
                        )
                      ),
                    ]),
                    _vm._v(" "),
                    _c("td", { staticClass: "text-right" }, [
                      _c("span", [
                        _vm._v(
                          _vm._s(
                            row.real_weighted != null
                              ? row.real_weighted + "%"
                              : "—"
                          )
                        ),
                      ]),
                      _vm._v(" "),
                      row.real_weighted != null && row.real_weighted <= 90
                        ? _c(
                            "span",
                            {
                              staticClass: "badge badge-warning ml-1",
                              attrs: {
                                title: "Minimum real: " + row.real_min + "%",
                              },
                            },
                            [_vm._v("⚠")]
                          )
                        : _vm._e(),
                    ]),
                    _vm._v(" "),
                    _c(
                      "td",
                      [
                        _c(
                          "router-link",
                          {
                            staticClass: "btn btn-sm btn-outline-secondary",
                            attrs: {
                              to:
                                "/admissions/cinema/" +
                                _vm.theatreCode +
                                "/" +
                                row.year,
                            },
                          },
                          [
                            _vm._v(
                              "\n                                Detail\n                            "
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                  ])
                }),
                0
              ),
              _vm._v(" "),
              _c("tfoot", [
                _c("tr", [
                  _vm._m(2),
                  _vm._v(" "),
                  _c("td", { staticClass: "text-right" }, [
                    _c("strong", [_vm._v(_vm._s(_vm.totalWeeks))]),
                  ]),
                  _vm._v(" "),
                  _c("td", { staticClass: "text-right" }, [
                    _c("strong", [
                      _vm._v(_vm._s(_vm.formatInt(_vm.totalAdmissions))),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("td", { staticClass: "text-right" }, [
                    _c("strong", [
                      _vm._v(
                        _vm._s(
                          _vm.totalWeeks
                            ? _vm.formatInt(
                                _vm.totalAdmissions / _vm.totalWeeks
                              )
                            : "—"
                        )
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("td", { staticClass: "text-right" }, [
                    _c("strong", [
                      _vm._v(_vm._s(_vm.formatInt(_vm.totalPreshow))),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("td", { staticClass: "text-right" }, [
                    _c("strong", [
                      _vm._v(
                        _vm._s(
                          _vm.totalWeeks
                            ? _vm.formatInt(_vm.totalPreshow / _vm.totalWeeks)
                            : "—"
                        )
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("td", { staticClass: "text-right" }, [
                    _c("strong", [
                      _vm._v(
                        _vm._s(_vm.pct(_vm.totalPreshow, _vm.totalAdmissions))
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("td", { attrs: { colspan: "2" } }),
                ]),
              ]),
            ]),
            _vm._v(" "),
            _c("p", { staticClass: "text-muted small mt-2 mb-0" }, [
              _vm._v(
                "\n                A cinema year runs from week C01 to the last cinema week (Wednesday to Tuesday).\n                "
              ),
              _vm.hiddenYears
                ? _c("span", [
                    _vm._v(_vm._s(_vm.hiddenYears) + " earlier year"),
                    _vm.hiddenYears !== 1
                      ? _c("span", [_vm._v("s")])
                      : _vm._e(),
                    _vm._v(
                      "\n                hidden (before " +
                        _vm._s(_vm.bucket.first_year) +
                        ", incomplete because of COVID); the API below returns them."
                    ),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c("strong", [_vm._v("All")]),
              _vm._v(" = every "),
              _c("code", [_vm._v("admissions_week")]),
              _vm._v(" row, "),
              _c("strong", [_vm._v("Preshow")]),
              _vm._v(" = rows with\n                "),
              _c("code", [_vm._v("saleshouse = BF")]),
              _vm._v(". "),
              _c("strong", [_vm._v("Real %")]),
              _vm._v(
                " is the admissions-weighted average of\n                "
              ),
              _c("code", [_vm._v("real")]),
              _vm._v(
                ": 97.5 = fully compiled from Cinedata, lower = partly estimated.\n                Same data as JSON: "
              ),
              _c("code", [
                _vm._v(
                  "GET /api/v1/admissions/cinema/" + _vm._s(_vm.theatreCode)
                ),
              ]),
              _vm._v(".\n            "),
            ]),
          ]),
        ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("thead", [
      _c("tr", [
        _c("th", [_vm._v("Period")]),
        _vm._v(" "),
        _c("th", { staticClass: "text-right shx-th-80" }, [_vm._v("# Weeks")]),
        _vm._v(" "),
        _c("th", { staticClass: "text-right" }, [_vm._v("All admissions")]),
        _vm._v(" "),
        _c("th", { staticClass: "text-right shx-th-120" }, [
          _vm._v("All avg / week"),
        ]),
        _vm._v(" "),
        _c("th", { staticClass: "text-right" }, [_vm._v("Preshow (BF)")]),
        _vm._v(" "),
        _c("th", { staticClass: "text-right shx-th-120" }, [
          _vm._v("Preshow avg / week"),
        ]),
        _vm._v(" "),
        _c("th", { staticClass: "text-right shx-th-80" }, [
          _vm._v("Preshow %"),
        ]),
        _vm._v(" "),
        _c("th", { staticClass: "text-right shx-th-80" }, [_vm._v("Real %")]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("thead", [
      _c("tr", [
        _c("th", { staticClass: "shx-th-100" }, [_vm._v("Cinema year")]),
        _vm._v(" "),
        _c("th", { staticClass: "text-right shx-th-80" }, [_vm._v("# Weeks")]),
        _vm._v(" "),
        _c("th", { staticClass: "text-right" }, [_vm._v("All admissions")]),
        _vm._v(" "),
        _c("th", { staticClass: "text-right shx-th-120" }, [
          _vm._v("All avg / week"),
        ]),
        _vm._v(" "),
        _c("th", { staticClass: "text-right" }, [_vm._v("Preshow (BF)")]),
        _vm._v(" "),
        _c("th", { staticClass: "text-right shx-th-120" }, [
          _vm._v("Preshow avg / week"),
        ]),
        _vm._v(" "),
        _c("th", { staticClass: "text-right shx-th-80" }, [
          _vm._v("Preshow %"),
        ]),
        _vm._v(" "),
        _c("th", { staticClass: "text-right shx-th-80" }, [_vm._v("Real %")]),
        _vm._v(" "),
        _c("th", { staticClass: "shx-th-100" }),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("td", [_c("strong", [_vm._v("Total")])])
  },
]
render._withStripped = true

export { render, staticRenderFns }